import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=13a0c367&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=ts&"
export * from "./Client.vue?vue&type=script&lang=ts&"
import style0 from "./Client.vue?vue&type=style&index=0&id=13a0c367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0c367",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
